import React, {useLayoutEffect, useRef} from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import useLanding from '../../model/useLanding';
import Hero from '../Hero/Hero';
import StartCards from '../StartCards/StartCards';
import Advantages from '../Advantages/Advantages';

import styles from './Landing.module.scss';

const Landing: React.FC = () => {
    const {facts, offered, included, price} = useLanding();
    const sectionRef = useRef<HTMLElement>(null);
    const startRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const section = sectionRef.current;
        const start = startRef.current;

        if (isTranslate() || !section || !start) {
            return;
        }

        const updateFill = () => {
            const sectionRect = section.getBoundingClientRect();
            const startRect = start.getBoundingClientRect();
            const center = startRect.top - sectionRect.top + startRect.height / 2;

            section.style.setProperty('--plug-fill', `${center}px`);
        };

        updateFill();

        const observer = new ResizeObserver(updateFill);
        observer.observe(section);

        return () => observer.disconnect();
    }, []);

    return (
        <section
            ref={sectionRef}
            className={cn(
                styles.section,
                styles[isTranslate() ? 'enBackground' : 'ruBackground'],
            )}
        >
            <div className={styles.content}>
                <Hero facts={facts}/>
                <div className={styles.start} ref={startRef}>
                    <StartCards/>
                </div>
                <Advantages offered={offered} included={included} price={price}/>
            </div>
        </section>
    );
};

export default Landing;
